// extracted by mini-css-extract-plugin
module.exports = {"icon":"IconBlock_icon__2sv-T","interactive":"IconBlock_interactive__27oY-"};